<template>
    <div>
        <div>
            <div
                class="border border-gray-dark relative rounded-md shadow-sm flex flex-col sm:flex-row"
            >
                <div class="flex">
                    <div
                        class="bg-gray-dark flex items-center rounded-tl sm:rounded-l p-2"
                    >
                        <label for="attribute" class="sr-only">Attribute</label>
                        <select
                            id="attribute"
                            name="attribute"
                            class="bg-transparent border-transparent h-full px-1 py-0 rounded-md sm:text-sm outline-none font-bold"
                            v-model="attribute"
                            @change="changed"
                        >
                            <option value="address">Email address</option>
                            <option value="domain">Domain</option>
                            <option value="subject">Subject</option>
                            <option value="body">Email body</option>
                        </select>
                    </div>
                    <div
                        class="bg-gray-lighter flex items-center rounded-tr sm:rounded-none w-full"
                    >
                        <label for="operator" class="sr-only">Operator</label>
                        <select
                            id="operator"
                            name="operator"
                            class="bg-transparent border-transparent h-full px-1 py-0 rounded-md sm:text-sm outline-none"
                            v-model="operator"
                            @change="changed"
                        >
                            <option value="equals_to">equals to</option>
                            <option value="starts_with">starts with</option>
                            <option value="ends_with">ends with</option>
                            <option value="contains">contains</option>
                        </select>
                    </div>
                </div>
                <input
                    type="text"
                    name="value"
                    id="value"
                    class="block border-gray-darker rounded-md sm:text-sm w-full outline-none p-2"
                    v-model="value"
                    @change="changed"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            attribute: undefined,
            operator: undefined,
            value: undefined,
            dirty: {},
        };
    },
    watch: {
        query() {
            this.reset();
        },
        attribute() {
            if (this.hasDirtyValue(this.attribute)) {
                // highest preference to a dirty value
                this.value = this.getDirtyValue(this.attribute);
            } else if (this.options[this.attribute]) {
                // then, to the provided options
                this.value = this.options[this.attribute];
            } else {
                // then, to a blank value
                this.value = "";
            }

            this.changed();
        },
        value() {
            // Whenever a value changes, mark it as dirty.
            this.setDirtyValue(this.attribute, this.value);
        },
    },
    mounted() {
        this.reset();
        this.setDirtyValue(this.attribute, this.value);
    },
    methods: {
        reset() {
            this.attribute = this.query.attribute;
            this.operator = this.query.operator;
            this.value = this.query.value;
        },
        changed() {
            this.$emit("change", {
                attribute: this.attribute,
                operator: this.operator,
                value: this.value,
            });
        },
        setDirtyValue(attribute, value) {
            this.dirty[attribute] = value;
        },
        getDirtyValue(attribute) {
            return this.dirty[attribute];
        },
        hasDirtyValue(attribute) {
            return !!this.dirty[attribute];
        },
    },
};
</script>

<style></style>
